
import { defineComponent, ref, computed } from "vue";

// ✅ Definir la interfaz para tipar los datos
interface TableRow {
  lastEstimation: string;
  nextEstimation: string;
  reason: string;
}

export default defineComponent({
  data() {
    return {
      // ✅ Especificar el tipo del array correctamente
      tableData: ref<TableRow[]>([
        {
          lastEstimation: "2025-03-03 10:30:00",
          nextEstimation: "2025-03-03 13:30:00",
          reason: "STOP_STATION",
        },
        {
          lastEstimation: "2025-03-05 10:30:00",
          nextEstimation: "2025-03-07 13:30:00",
          reason: "STOP_STATION",
        },
        {
          lastEstimation: "2025-03-06 10:30:00",
          nextEstimation: "2025-03-09 13:30:00",
          reason: "STOP_STATION",
        },
        {
          lastEstimation: "2025-03-10 10:30:00",
          nextEstimation: "2025-03-12 13:30:00",
          reason: "UNKNOWN_STATUS",
        },
      ]),
      currentPage: ref(1),
      rowPerPage: ref(10),
      startDatePicker: ref<string | null>(null),
      endDatePicker: ref<string | null>(null),
    };
  },
  computed: {
    filteredTableData(): TableRow[] {
      if (!this.startDatePicker && !this.endDatePicker) {
        return this.tableData;
      }

      return this.tableData.filter((row: TableRow) => {
        const rowDate = new Date(row.lastEstimation).getTime();
        const start = this.startDatePicker ? new Date(this.startDatePicker).getTime() : -Infinity;
        const end = this.endDatePicker ? new Date(this.endDatePicker).getTime() : Infinity;
        return rowDate >= start && rowDate <= end;
      });
    },
  },
  methods: {
    filterReason(value: string, row: TableRow) {
      return row.reason === value;
    },
    disabledDate(date: Date) {
      return date > new Date();
    },
    disabledFutureDate(date: Date) {
      return this.startDatePicker ? date < new Date(this.startDatePicker) : false;
    },
  },
});
